import { render, staticRenderFns } from "./QuotationsCRM.vue?vue&type=template&id=1647f95e&scoped=true"
import script from "./QuotationsCRM.vue?vue&type=script&lang=js"
export * from "./QuotationsCRM.vue?vue&type=script&lang=js"
import style0 from "./QuotationsCRM.vue?vue&type=style&index=0&id=1647f95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647f95e",
  null
  
)

export default component.exports